"use client"

import { useEffect } from "react"
import dynamic from "next/dynamic"
import { usePathname } from "next/navigation"

// Import and re-export the context from the new file
import { useCommandK, CommandKProvider } from './CommandKContext'
export { useCommandK, CommandKProvider }

// Import shared types
import { CommandDialogProps } from './CommandTypes'

// Use a more explicit dynamic import
const CommandDialog = dynamic<CommandDialogProps>(
  () => import('./CommandDialog').then(mod => ({ default: mod.default })),
  {
    ssr: false,
    loading: () => null
  }
)

export default function CommandK({
  banner,
  defaultView,
}: CommandDialogProps) {
  const pathname = usePathname()
  const { open, show, close } = useCommandK()
  
  // This effect needs to be in the main component to listen for keyboard shortcuts
  // even when the command palette is closed
  useEffect(() => {
    const down = (e: {
      key: string
      metaKey: any
      ctrlKey: any
      preventDefault: () => void
    }) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        show()
      }
    }

    document.addEventListener("keydown", down)
    return () => document.removeEventListener("keydown", down)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // This effect needs to be in the main component to close the command palette
  // when the pathname changes
  useEffect(() => {
    close()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  // Only render the CommandDialog when it's open
  if (!open) return null
  
  return (
    <CommandDialog 
      banner={banner} 
      defaultView={defaultView} 
    />
  )
}
